import React from 'react'
import { PropTypes } from 'prop-types'
import { css, withStyles } from '../../styles/withStyles'
import Styles from './styles'

const Clearfix = props => <div {...css(props.styles.clearfix)} />

Clearfix.propTypes = {
  styles: PropTypes.object.isRequired
}

export default withStyles(Styles)(Clearfix)



// WEBPACK FOOTER //
// ./components/clearfix/index.js